module.exports = __webpack_public_path__ + "static/media/census.3865a67d.svg";